import { BillDetailLabel, BillItemPrice, OrderBillTable } from './styled';
import { getExtrasLabel } from './utils';
import { centsToPrice } from '@/utils/formatter';
import { FaLock } from 'react-icons/fa';
import React from 'react';
import i18n from '@/utils/i18n';

export const OrderBill = function ({
  order,
  isAdmin,
}: {
  order: any;
  isAdmin: boolean;
}) {
  const nettoConsumerTotal =
    order &&
    (order.vat_total || []).reduce(
      (acc: number, vatItem: any) => vatItem.vat_amount + acc,
      0,
    );

  return (
    <OrderBillTable className="table-sm table">
      <thead>
        <tr>
          <th>{i18n.t('Order:bill')}</th>
          <th> </th>
        </tr>
      </thead>
      <tbody>
        {(order.items || []).map((item: any) => {
          return (
            <tr>
              <td>
                {item.quantity}x {item.name}
                {item.extras && (
                  <BillDetailLabel>
                    {getExtrasLabel(item.extras)}
                  </BillDetailLabel>
                )}
                {item.comment && (
                  <BillDetailLabel>
                    {i18n.t('Order:customerComment')}: {item.comment}
                  </BillDetailLabel>
                )}
              </td>
              <BillItemPrice>
                {centsToPrice(item.price, order.currency)}
              </BillItemPrice>
            </tr>
          );
        })}

        <tr>
          <td>{i18n.t('Order:itemTotal')}</td>
          <BillItemPrice>
            {centsToPrice(order.item_total, order.currency)}
          </BillItemPrice>
        </tr>
        <tr>
          <td>{i18n.t('Order:platformFee')}</td>
          <BillItemPrice>
            {centsToPrice(order.platform_fee, order.currency)}
          </BillItemPrice>
        </tr>
        {order.type === 'DELIVERY_ORDER' && (
          <tr>
            <td>{i18n.t('Order:deliveryFee')}</td>
            <BillItemPrice>
              {centsToPrice(order.delivery_fee, order.currency)}
            </BillItemPrice>
          </tr>
        )}
        {(order.discount_amount || 0) > 0 && (
          <tr>
            <td>
              {i18n.t('Order:discount')}
              <BillDetailLabel>
                {
                  (
                    order.campaign || {
                      offer_name: i18n.t('Order:unknownCampaign'),
                    }
                  ).offer_name
                }
              </BillDetailLabel>
            </td>
            <BillItemPrice>
              -{centsToPrice(order.discount_amount, order.currency)}
            </BillItemPrice>
          </tr>
        )}
        {(order.discount_by_vytal_credits || 0) > 0 && (
          <tr>
            <td>{i18n.t('Order:vytalCredits')}</td>
            <BillItemPrice>
              -{centsToPrice(order.discount_by_vytal_credits, order.currency)}
            </BillItemPrice>
          </tr>
        )}
        <tr>
          <td>{i18n.t('Order:net')}</td>
          <BillItemPrice>
            {centsToPrice(order.total - nettoConsumerTotal, order.currency)}
          </BillItemPrice>
        </tr>

        {order.vat_total.map((vatItem: any) => (
          <tr>
            <td>
              {vatItem.vat_rate / 10}% {i18n.t('Order:vat')}
            </td>
            <BillItemPrice>
              {centsToPrice(vatItem.vat_amount, order.currency)}
            </BillItemPrice>
          </tr>
        ))}

        <tr>
          <td>
            <b>{`${i18n.t('Order:total')} (${i18n.t('Order:payed')} ✓)`}</b>
          </td>
          <BillItemPrice>
            <b>{centsToPrice(order.total, order.currency)}</b>
          </BillItemPrice>
        </tr>

        {(order.store_discount_amount || 0) > 0 && (
          <tr>
            <td>{i18n.t('Order:discountStore')}</td>
            <BillItemPrice>
              -{centsToPrice(order.store_discount_amount, order.currency)}
            </BillItemPrice>
          </tr>
        )}

        <tr>
          <td>{i18n.t('Order:storeTotal')}</td>
          <BillItemPrice>
            {centsToPrice(order.store_total, order.currency)}
          </BillItemPrice>
        </tr>
        {order.store_vat_total.map((vatItem: any) => (
          <tr>
            <td>
              {vatItem.vat_rate / 10}% {i18n.t('Order:vat')}
            </td>
            <BillItemPrice>
              {centsToPrice(vatItem.vat_amount, order.currency)}
            </BillItemPrice>
          </tr>
        ))}

        {isAdmin && (
          <tr>
            <td>
              <FaLock /> Comission Rate
            </td>
            <BillItemPrice>{order.commission_rate / 10}%</BillItemPrice>
          </tr>
        )}

        {isAdmin && (
          <tr>
            <td>
              <FaLock /> Transfer Amount
            </td>
            <BillItemPrice>
              {centsToPrice(order.transfer_amount, order.currency)}
            </BillItemPrice>
          </tr>
        )}
      </tbody>
    </OrderBillTable>
  );
};
